import { myAxios } from "./axios";

export function getHousings(data, { page, perPage }) {
  let config = {
    params: {
      page,
      perPage,
      ...(data || {}),
    },
  };
  return myAxios.get("/housing", config);
}

export function getHousing(id) {
  return myAxios.get("/housing/" + id);
}

export function addHousing(data) {
  return myAxios.post("/housing/create", data);
}

export function editHousing(id, data) {
  return myAxios.put("/housing/" + id + "/update", data);
}

export function deleteHousing(id) {
  return myAxios.delete("/housing/" + id + "/delete");
}

export function getAvailableBeds(data) {
  let config = {
    params: {
      ...(data || {}),
    },
  };
  return myAxios.get("/housing/available-beds", config);
}


export function getHousingRenters(data, { page, perPage }) {
  let config = {
      params: {
          page,
          perPage,
          ...(data || {})
      },
  }
  return myAxios.get(`/housing/${data.housingId}/renters`, config)
}
